import {SOPostRole} from '../../core/role/so-post-role';
import {RoleCore} from './role.core';
import {SOGetRole} from '../../core/role/so-get-role';
import {FormField, SelectionOption} from 'lionheartland';
import {postRoleFormFieldOptions} from './post-role-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostRole extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postRoleFormFieldOptions);

  RequestClass = SOPostRole

  constructor(
    public entityCore: RoleCore
  ) {
    super();
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('identifier'),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}